/** Undo/export document slice — `state.kind` + `state.value`. */
export interface SugarStateSlice<T = unknown> {
  kind: string;
  value: T;
}

export type HistoryDir = "undo" | "redo";

/** Object that participates in data-oriented history / scene export. */
export interface SugarObject {
  uuid: string;
  state?: SugarStateSlice;
  applyState?(slice: SugarStateSlice, dir: HistoryDir): void;
}

const _rootsByUuid = new Map<string, SugarObject>();

/** `state` slice'ı olan objeleri history/export registry'sine ekler. */
export function trackStateRoot(obj: unknown): void {
  if (!isSugarObject(obj)) return;
  const slice = obj.state;
  if (!slice?.kind) return;
  _rootsByUuid.set(obj.uuid, obj);
}

export function untrackStateRoot(obj: unknown): void {
  if (!isSugarObject(obj)) return;
  _rootsByUuid.delete(obj.uuid);
}

export function getRegisteredStateRoots(): readonly SugarObject[] {
  return [..._rootsByUuid.values()];
}

export function getStateRootByUuid(uuid: string): SugarObject | undefined {
  return _rootsByUuid.get(uuid);
}

export function isSugarObject(o: unknown): o is SugarObject {
  return (
    typeof o === "object" &&
    o !== null &&
    typeof (o as SugarObject).uuid === "string"
  );
}

export function getStateSlice(obj: SugarObject): SugarStateSlice | undefined {
  return obj.state;
}
